export default {
  methods: {
    validate(fields) {
      if (!fields && !Array.isArray(fields)) return
      for (let field of fields) {
        if (!this[field]) continue
        for (let rule of this[field].rules) {
          if (typeof this.Rules[rule](this[field].value) === 'string') {
            this.$set(this[field], 'error', this.Rules[rule](this[field].value))
            this.$set(this[field], 'state', false)
            return false
          } else if (this.Rules[rule](this[field].value)) {
            this.$set(this[field], 'error', null)
            this.$set(this[field], 'state', true)
          }
        }
      }
      return true
    },
  },
}
